<template>
    <tr @click.stop.prevent="showChannelGroupDetail" class="clickable">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="channelGroup.id_group"
               :value="channelGroup.id_group"
               @change="onChange"
               :checked="isChecked"
               @click.stop
        />
        <label :for="channelGroup.id_group" @click.stop v-translate>Vybrat</label>
      </td>
      <td data-th="Název" class="first_data"><strong>{{ channelGroup.name }}</strong></td>
      <td data-th="Typ skupiny">{{ channelGroupType }}</td>
      <td data-th="Počet kanálů" class="last_data">{{ this.channelGroup.channels.length }}</td>
      <td data-th="Uživatelský profil">
        <span :key="channelGroup.id_subscriber_profile">
          <entity-link :id="channelGroup.id_subscriber_profile" type="subscriberProfile">{{ channelGroup.subscriber_profile_name }}</entity-link>
        </span>
      </td>
      <td data-th="Tématická skupina">
        <span :key="channelGroup.thematic_group_id">
          <entity-link :id="channelGroup.thematic_group_id" type="thematicGroup">{{translatedThematicGroupName}}</entity-link>
        </span>
      </td>
      <td v-if="channelGroup.device_ids.length === 0" data-th="Přiřazená zařízení">{{ $gettext("Všechna zařízení") }}</td>
      <td v-else data-th="Přiřazená zařízení">
          <span v-for="(idDevice, index) in channelGroup.device_ids" :key="idDevice">
              <span v-if="index > 0">,</span>
              <entity-link :id="idDevice" type="device">{{ devices[idDevice] }}</entity-link>
          </span>
      </td>
      <td data-th="Upraveno" v-html="$_date_formatFull(channelGroup.updated_timestamp)"></td>
      <td class="no_padding edit">
          <div class="edit_inner">
              <a
                  v-if="isEditable"
                  @click.stop="duplicateChannelGroup"
                  class="btn btn_action btn_grey btn_duplicate"
                  :title="$gettext('Duplikovat')"
                  v-translate
              >Duplikovat</a>
              <a
                  @click.stop="resetChannelGroup"
                  v-if="channelGroup.system && channelGroup.is_modified && isEditable"
                  class="btn btn_action btn_grey btn_reset"
                  :title="$gettext('Resetovat')"
                  v-translate>Resetovat</a>
              <a
                  @click.stop="removeChannelGroup"
                  v-if="!channelGroup.system && isEditable"
                  class="btn btn_action btn_grey btn_delete"
                  :title="$gettext('Smazat')"
                  v-translate>Smazat</a>
          </div>
      </td>
    </tr>
</template>

<script>
import links from "../../../mixins/links";
import EntityLink from "../../../common/EntityLink.vue";
import { iso6391ToIso6392 } from "../../../../utils/helpers";

export default {
    name: "ChannelGroupRow",
  components: { EntityLink },
    props: {
        channelGroup: Object,
        devices: Object,
        selectedEntities: Array,
        isEditable: Boolean,
    },
    mixins: [links],
    methods: {
        resetChannelGroup() {
            this.$emit('resetChannelGroup', this.channelGroup.system ? this.channelGroup.id_group : this.channelGroup.id);
        },
        duplicateChannelGroup() {
            this.$emit('duplicateChannelGroup', this.channelGroup);
        },
        removeChannelGroup() {
            this.$emit('removeChannelGroup', this.channelGroup.system ? this.channelGroup.id_group : this.channelGroup.id);
        },
        showChannelGroupDetail() {
            this.$emit('showChannelGroupDetail', this.channelGroup.id_group);
        },
        onChange: function (e) {
          this.$emit('input', e)
        },
    },
    computed: {
        channelGroupType() {
            if (this.channelGroup.type === "tv") {
                return this.$gettext("Televize");
            } else if (this.channelGroup.type === "radio") {
                return this.$gettext("Rádia");
            } else if (this.channelGroup.type === "combined") {
              return this.$gettext("Kombinovaná");
            } else {
                return this.$gettext("Uživatelská skupina");
            }
        },
        translatedThematicGroupName() {
            const language = iso6391ToIso6392(this.$language.current.toLowerCase())
            return this.channelGroup.thematic_group_translations && this.channelGroup.thematic_group_translations[language]
                ? this.channelGroup.thematic_group_translations[language]
                : this.channelGroup.thematic_group_name
        },
      isChecked() {
        return this.selectedEntities.indexOf(String(this.channelGroup.id)) > -1
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/ChannelGroupRow.vue